import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { SocialMediaContainer, ShareLink, CopyModal, ModalBG, ModalButton } from './SocialShare.style'
import { ButtonArrow } from '../../../shared/Buttons/Buttons.styles'
import ArrowRight from '../Icons/ArrowRight'
import { FACEBOOK_SHARE_URL, TWITTER_SHARE_URL, LINE_SHARE_URL } from '../../../constants/API/url'
import { FACEBOOK_SHARE_LABEL, TWITTER_SHARE_LABEL, LINE_SHARE_LABEL, COPY_LINK_LABEL, COPIED_LINK_TEXT, CONFIRM_COPY_TEXT } from '../../../locales'
import Facebook from '../Icons/Facebook'
import Twitter from '../Icons/Twitter'
import Line from '../Icons/Line'
import Copy from '../Icons/Copy'

class SocialShare extends Component {
  state = {
    showModal: false,
  }

  openCopyModal = () => {
    this.setState({
      showModal: true,
    })
  }

  closeCopyModal = () => {
    this.setState({
      showModal: false,
    })
  }

  render() {
    const { pageURL, mobileOnly } = this.props
    const { showModal } = this.state

    return (
      <SocialMediaContainer mobileOnly={mobileOnly}>
        <ShareLink
          href={FACEBOOK_SHARE_URL + pageURL}
          target="_blank"
          aria-label={FACEBOOK_SHARE_LABEL}
        >
          <svg viewBox="0 0 512 512">
            <Facebook />
          </svg>
        </ShareLink>
        <ShareLink
          href={TWITTER_SHARE_URL + pageURL}
          target="_blank"
          aria-label={TWITTER_SHARE_LABEL}
        >
          <svg viewBox="0 0 512 512">
            <Twitter />
          </svg>
        </ShareLink>
        <ShareLink
          href={LINE_SHARE_URL + encodeURIComponent(pageURL)}
          target="_blank"
          aria-label={LINE_SHARE_LABEL}
        >
          <svg viewBox="0 0 512 512">
            <Line />
          </svg>
        </ShareLink>
        <CopyToClipboard
          text={pageURL}
          onCopy={this.openCopyModal}
          aria-label={COPY_LINK_LABEL}
        >
          <ShareLink href="">
            <svg viewBox="0 0 512 512">
              <Copy />
            </svg>
          </ShareLink>
        </CopyToClipboard>

        <ModalBG visible={showModal}>
          <CopyModal visible={showModal}>
            <p>
              {COPIED_LINK_TEXT}
            </p>
            <ModalButton >
              <button type="button" onClick={this.closeCopyModal}>
                {CONFIRM_COPY_TEXT}
                <ButtonArrow viewBox="0 0 12 21"><ArrowRight /></ButtonArrow>
              </button>
            </ModalButton>
          </CopyModal>
        </ModalBG>
      </SocialMediaContainer>
    )
  }
}

SocialShare.propTypes = {
  pageURL: PropTypes.string.isRequired,
  mobileOnly: PropTypes.bool,
}

SocialShare.defaultProps = {
  mobileOnly: false,
}

export default SocialShare
